export const origins = [
  'https://folha.novacoop.com.br',
  'https://folha.4bee.com.br',
  'http://jerusalem:8000',
];

if (process.env.NODE_ENV === 'development') {
  origins.push('http://localhost:8080');
}

export const sendMessageToParentWindow = (message) => {
  origins.forEach((origin) => {
    window.parent.postMessage(message, origin);
  });
};
